export const formatPrice = (amount) =>
  new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 }).format(amount);

export const formatDate = (isoString) =>
  new Date(isoString).toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric" });

export const CATEGORIES = ["Ropa","Calzado","Accesorios","Electronica","Hogar","Juguetes","Alimentos","Cosmeticos","Libros","Otros"];

export const COLORS = ["Negro","Blanco","Gris","Rojo","Rosa","Naranja","Amarillo","Verde","Azul","Violeta","Marron","Beige","Multicolor"];

export const PAYMENT_LABELS = { mercadopago: "Mercado Pago" };

export const SHIPPING_OPTIONS = [
  { value: "no", label: "Sin envio - solo retiro en persona" },
  { value: "gratis", label: "Envio incluido en el precio" },
  { value: "comprador", label: "Envio con costo aparte (lo paga el comprador)" },
];

export const ZONES = [
  "Palermo","Belgrano","Villa Urquiza","Caballito","Flores","Once","Villa Crespo",
  "Almagro","Recoleta","Barrio Norte","San Telmo","Microcentro","Nunez","Colegiales",
  "Devoto","Villa del Parque","Liniers","Mataderos","Lugano","Otro"
];

export const calcCommission = (price, rate = 0.05) => ({
  commission: parseFloat((price * rate).toFixed(2)),
  sellerReceives: parseFloat((price * (1 - rate)).toFixed(2)),
});

// Campos extra por categoria
export const CATEGORY_FIELDS = {
  Ropa: [
    { key: "talle", label: "Talle", type: "select", options: ["XS","S","M","L","XL","XXL","XXXL","Unico"] },
    { key: "genero", label: "Genero", type: "select", options: ["Mujer","Hombre","Unisex","Nino","Nina"] },
    { key: "material", label: "Material", type: "text", placeholder: "Ej: Algodon 100%, poliester..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo con etiqueta","Como nuevo","Muy bueno","Bueno","Regular"] },
    { key: "medidas", label: "Medidas (opcional)", type: "text", placeholder: "Ej: Largo 65cm, ancho 50cm" },
  ],
  Calzado: [
    { key: "numero", label: "Numero / Talle", type: "text", placeholder: "Ej: 38, 39..." },
    { key: "genero", label: "Genero", type: "select", options: ["Mujer","Hombre","Unisex","Nino","Nina"] },
    { key: "material", label: "Material", type: "text", placeholder: "Ej: Cuero, tela, sintetico..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo con caja","Como nuevo","Muy bueno","Bueno","Regular"] },
  ],
  Accesorios: [
    { key: "tipo", label: "Tipo de accesorio", type: "text", placeholder: "Ej: Cartera, cinturon, lentes..." },
    { key: "material", label: "Material", type: "text", placeholder: "Ej: Cuero, tela, metal..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo","Como nuevo","Muy bueno","Bueno","Regular"] },
  ],
  Electronica: [
    { key: "marca", label: "Marca", type: "text", placeholder: "Ej: Samsung, Apple, Sony..." },
    { key: "modelo", label: "Modelo", type: "text", placeholder: "Ej: Galaxy S21, iPhone 13..." },
    { key: "almacenamiento", label: "Almacenamiento / RAM", type: "text", placeholder: "Ej: 128GB, 8GB RAM..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo en caja","Como nuevo","Muy bueno","Bueno","Con detalle"] },
    { key: "accesorios", label: "Incluye accesorios", type: "text", placeholder: "Ej: Cargador, auriculares, funda..." },
    { key: "garantia", label: "Garantia", type: "text", placeholder: "Ej: 6 meses de fabrica, sin garantia..." },
  ],
  Hogar: [
    { key: "tipo", label: "Tipo de articulo", type: "text", placeholder: "Ej: Silla, lampara, cuadro..." },
    { key: "material", label: "Material", type: "text", placeholder: "Ej: Madera, metal, tela..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo","Como nuevo","Muy bueno","Bueno","Regular"] },
    { key: "dimensiones", label: "Dimensiones (opcional)", type: "text", placeholder: "Ej: 80cm x 60cm x 40cm" },
  ],
  Juguetes: [
    { key: "edadRecomendada", label: "Edad recomendada", type: "text", placeholder: "Ej: 3 a 8 anos" },
    { key: "marca", label: "Marca (opcional)", type: "text", placeholder: "Ej: Lego, Mattel..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo en caja","Como nuevo","Muy bueno","Bueno","Usado"] },
    { key: "piezasCompletas", label: "Piezas completas", type: "select", options: ["Si, completo","Faltan piezas menores","Incompleto"] },
  ],
  Alimentos: [
    { key: "ingredientes", label: "Ingredientes principales", type: "text", placeholder: "Ej: Harina, azucar, cacao..." },
    { key: "pesoContenido", label: "Peso / Contenido", type: "text", placeholder: "Ej: 500g, 1 litro, 12 unidades..." },
    { key: "vencimiento", label: "Fecha de vencimiento", type: "text", placeholder: "Ej: 30/06/2025" },
    { key: "apto", label: "Apto para", type: "text", placeholder: "Ej: Veganos, celiacs, diabeticos..." },
  ],
  Cosmeticos: [
    { key: "marca", label: "Marca", type: "text", placeholder: "Ej: MAC, Revlon, natural..." },
    { key: "tipoProducto", label: "Tipo de producto", type: "text", placeholder: "Ej: Labial, crema, perfume..." },
    { key: "volumenPeso", label: "Volumen / Peso", type: "text", placeholder: "Ej: 50ml, 100g..." },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo sellado","Nuevo sin sellar","Usado poco","Usado"] },
    { key: "vencimiento", label: "Vencimiento (opcional)", type: "text", placeholder: "Ej: 12/2026" },
  ],
  Libros: [
    { key: "autor", label: "Autor", type: "text", placeholder: "Ej: Gabriel Garcia Marquez" },
    { key: "editorial", label: "Editorial (opcional)", type: "text", placeholder: "Ej: Planeta, Sudamericana..." },
    { key: "idioma", label: "Idioma", type: "select", options: ["Espanol","Ingles","Hebreo","Frances","Portugues","Otro"] },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo","Como nuevo","Bueno","Regular"] },
    { key: "anio", label: "Ano de edicion (opcional)", type: "text", placeholder: "Ej: 2020" },
  ],
  Otros: [
    { key: "tipo", label: "Tipo de articulo", type: "text", placeholder: "Describe brevemente que es" },
    { key: "estado", label: "Estado", type: "select", options: ["Nuevo","Como nuevo","Muy bueno","Bueno","Regular"] },
  ],
};
